import React, { useState } from "react";
import { X } from "lucide-react";
import { apiPost } from "../../API/Api_Url";
import { toast } from "react-toastify";

function AddMaterialPaymentModal({ isOpen, onClose, SelecetdRequest, GetUserAllDeliveredMaterialRequest }) {
    const [Amount, setAmount] = useState("");
    const [Mode, setMode] = useState("UPI");
    const [Note, setNote] = useState("");
    const [IsLoading, setIsLoading] = useState(false);

    const UserAddPaymentTransaction = async () => {
        const trimmedNote = Note?.trim();

        if (!Amount || isNaN(Amount) || Number(Amount) <= 0) {
            return toast.error("Please enter a valid payment amount.");
        }
        if (!Mode) {
            return toast.error("Please select a payment mode.");
        }
        const payload = {
            Amount: Number(Amount),
            Mode,
            Note: trimmedNote,
        };

        try {
            setIsLoading(true);
            const response = await apiPost(
                `/api/user/UserAddPaymentTransaction/${SelecetdRequest?._id}`,
                payload
            );

            if (response?.data) {
                toast.success(
                    response?.data?.message ||
                    response?.message ||
                    "Payment added successfully!"
                );
                setAmount("");
                setMode("");
                setNote("");
                onClose();
                GetUserAllDeliveredMaterialRequest();
            } else {
                toast.error(response?.message || "Failed to add payment");
            }
        } catch (error) {
            console.error("Error adding payment:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">Add Payment</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Amount (₹)</label>
                        <input
                            type="number"
                            value={Amount}
                            onChange={(e) => setAmount(e.target.value)}
                            required
                            className="w-full mt-1 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            placeholder="Enter amount"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Mode</label>
                        <select
                            value={Mode}
                            onChange={(e) => setMode(e.target.value)}
                            className="w-full mt-1 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        >
                            <option value="">Please Select</option>
                            <option value="UPI">UPI</option>
                            <option value="Online">Online</option>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Note</label>
                        <textarea
                            value={Note}
                            onChange={(e) => setNote(e.target.value)}
                            rows={2}
                            className="w-full mt-1 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            placeholder="Add a note (optional)"
                        />
                    </div>
                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-200 rounded-lg text-gray-700 hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => { UserAddPaymentTransaction() }}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            {IsLoading ? 'Please Wait' : 'Add Payment'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddMaterialPaymentModal;
